<template>
    <div class="breviary">
        <div class="content">
            <div class="banner">
                <!-- 背景图 -->
                <div v-if="levelNum == 1" class="zt1"></div>
                <div v-else-if="levelNum == 2" class="zt2"></div>
                <div v-else-if="levelNum == 3" class="zt3"></div>
                <div v-else-if="levelNum == 4" class="zt4"></div>
                <!-- 状态1 -->
                <div class="state_1" style="" v-if="studyInfo.progress==0" @click="startStudy(0)">开始学习</div>
                <!-- 状态2 -->
                <div class="state_2" v-if="studyInfo.progress == 1">
                    <div id="main1" style="width: 1.38rem;height:1.28rem; position: absolute; left: 3%; top: 10%;" ref="main_t"></div>
                    <span class="easc">{{this.e}}%</span>
                    <span class="easc_1">完成度</span>
                    <div class="tet">
                        <p>上次学到</p>
                        <p class="course-name">{{studyInfo.goodsName}}</p>
                    </div>
                    <a class="btn" style="line-height: 0.52rem;padding: 0;" @click="startStudy(1)">开始学习</a>
                </div>
                <!-- 状态3 -->
                <div class="state_3" v-if="studyInfo.progress >= 2">
                    <div id="main1" style="width: 1.38rem;height:1.28rem; position: absolute; left: 3%; top: 10%;" ref="main_t"></div>
                    <span class="easc">{{this.e}}%</span>
                    <span class="easc_1">完成度</span>
                    <div class="tet">
                        <p>您已完成{{curLevelName}}课程</p>
                        <p><span class="tet_1">{{nextLevelName}}</span>课程已解锁</p>
                    </div>
                    <a class="btn" style="line-height: 0.52rem;padding: 0;" v-if="studyInfo.progress == 2" @click="toTest()">进阶考试</a>
                    <a class="btn" style="line-height: 0.52rem;padding: 0;" v-else @click="nextStudy()">开始学习</a>
                </div>
            </div>
            <!-- 大图 -->
            <div class="list_img" @click="toCouver">
                <img v-if="levelNum === 1" src="//images.jinku.com/newjk/org/images/newble_images/breviary_newble.png"
                     alt="">
                 <img v-else-if="levelNum === 2" src="//images.jinku.com/newjk/org/images/newble_images/breviary_expert.png"
                     alt="">
                 <img v-else-if="levelNum === 4" src="//images.jinku.com/newjk/org/images/newble_images/breviary_lombard.png"
                     alt="">
                <img v-else-if="list.filter(item =>item.id == user_id).length !== 0 && levelNum === 3" src="//images.jinku.com/newjk/org/images/newble_images/breviary_elite_v2.png"
                    alt="">
                <img v-else="list.filter(item =>item.id == user_id).length == 0 && levelNum === 3" src="//images.jinku.com/newjk/org/images/newble_images/breviary_elite.png"
                    alt="">
                <img src="//images.jinku.com/newjk/org/images/newble_images/breviary_btn.png" alt="" style="width: 2.02rem;height: .4rem;"
                    class="ovesr">
            </div>
        </div>
        <bar></bar>
    </div>
</template>

<script>
    const echarts = require('echarts');
    import http from "../../lib/http.js";
    import bar from "../tab-bar/bar.vue";
    export default {
        name: 'breviary',
        data() {
            return {
                e: 0,
                studyInfo: {
                    progress: 0, // 0=未开始；1=学习中；2=学习完成(未通过考试)；3=学习完成（已通过考试）
                    goodsId: 0,
                    goodsName: ''
                },
                showCFDR: false, // 显示财富达人
                showCFJY: false, // 显示财富精英
                showSRYHJ: false, // 显示私人银行家
                structureArr: [],
                levelNum: "",
                userLeafLevel: 0,
                firstGoodsId: 0,
                user_id: '',
                list: [
                    {
                        id:2351570,
                        name:'0'
                    },
                    {
                        id:2351572,
                        name:'1'
                    },
                    {
                        id:2351574,
                        name:'2'
                    },
                    {
                        id:2351576,
                        name:'3'
                    },
                    {
                        id:2351578,
                        name:'4'
                    },
                    {
                        id:2299652,
                        name:'5'
                    },
                    {
                        id:2297811,
                        name:'6'
                    }
                ],
                allLevel: {
                    '1': '财富新人',
                    '2': '财富达人',
                    '3': '财富精英',
                    '4': '私人银行家'
                },
                allLevelUrl: {
                    '1': '/Newble',
                    '2': '/Expert',
                    '3': '/Elite',
                    '4': '/Lombard'
                },
            }
        },
        components: {
            bar
        },
        computed: {
            curLevelName: function() {
                return this.allLevel[this.levelNum] || '';
            },
            nextLevelName: function() {
                return this.allLevel[this.levelNum + 1] || '';
            }
        },
        methods: {
            myMain() {
                let myMain_t = echarts.init(document.getElementById('main1'));
                myMain_t.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: "{d}%",
                        show: false
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'center',
                        show: false
                    },
                    color: ['#068CFD', 'rgba(0,0,0,.1)'], //颜色
                    series: {
                        name: '',
                        type: 'pie',
                        radius: ['65%', '85%'],
                        avoidLabelOverlap: true,
                        hoverAnimation: false,
                        label: {
                            normal: {
                                show: true,
                                position: 'left'
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: [{
                                value: this.e,
                                name: ''
                            },
                            {
                                value: 100 - this.e,
                                name: ''
                            }
                        ]
                    }

                })
            },
            startStudy(firstStudy /*是否首次学习*/ ) { // 开始学习
                var goodsId = firstStudy ? (this.firstGoodsId || this.studyInfo.goodsId) : this.studyInfo.goodsId;
                if (!goodsId) return;
                var a = document.createElement("a");
                a.setAttribute("href", 'https://m.jinku.com/org/video/?goods_id=' + goodsId);
                a.setAttribute("target", "_blank");
                a.click();
                document.getElementsByTagName("body")[0].appendChild(a);
                a.remove();
            },
            nextStudy() { // 开始下一阶段课程学习
                var url = this.allLevelUrl[this.levelNum + 1];
                url && this.toAppUrl(url);
            },
            toCouver() {
                if (this.levelNum == 1) {
                    this.$router.push('/Newble');
                } else if (this.levelNum == 2) {
                    this.$router.push('/Expert');
                } else if (this.levelNum == 3) {
                    this.$router.push('/Elite');
                } else if (this.levelNum == 4) {
                    this.$router.push('/Lombard');
                }
                this.list.forEach((item, i) => {
                    if (this.user_id == item.id) {
                        this.$router.push("/Elitev2");
                    }
                })
            },
            getUserInfo() {
                const self = this;
                return http({
                    method: "post",
                    url: "/org/user/get",
                    data: ""
                }).then(function(res) {
                    self.user_name = res.data.user_name;
                    self.user_id = res.data.user_id;
                    self.user_level = res.data.org_user_level;
                    self.user_rank_name = res.data.org_user_rank_name
                    if (self.user_level < 4 && self.user_level > 0) {
                        var next_user_level = self.user_level + 1;
                        if (param.USER_LEVEL_NAME[param.BANKING_ID][next_user_level] != undefined) {
                            self.next_user_rank_name = param.USER_LEVEL_NAME[param.BANKING_ID][next_user_level];
                        }
                    }
                    if (param.COURSE_LEVEL_NAME[param.BANKING_ID][self.user_level] != undefined) {
                        self.course_level = param.COURSE_LEVEL_NAME[param.BANKING_ID][self.user_level];
                    }
                }).catch(function(err) {

                });
            },
        },
        mounted() {
            // this.levelNum = this.$attrs && this.$attrs.levelNum || 0;
            this.studyInfo.progress > 0 && this.myMain();
        },
        created() {
            this.levelNum = this.$route.query.levelNum;
            this.getUserInfo();
        }
    };
</script>

<style scoped>
    .content {
        width: 100%;
        position: relative;
    }

    .course-name {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 2.58rem;
        white-space: nowrap;
    }

    .banner {
        width: 100%;
        height: 2.8rem;
        position: relative;
    }

    .zt1 {
        width: 100%;
        height: 2.8rem;
        background-size: 100% 100%;
        background-image: url(//images.jinku.com/newjk/org/images/newble_images/newble_1.png);
    }

    .zt2 {
        width: 100%;
        height: 2.8rem;
        background-size: 100% 100%;
        background-image: url(//images.jinku.com/newjk/org/images/expert_images/expert_banner_01.png);
    }

    .zt3 {
        width: 100%;
        height: 2.8rem;
        background-size: 100% 100%;
        background-image: url(//images.jinku.com/newjk/org/images/elite_images/elite_banner_01.png);
    }

    .zt4 {
        width: 100%;
        height: 2.8rem;
        background-size: 100% 100%;
        background-image: url(//images.jinku.com/newjk/org/images/lombard_images/Lombard_01.png);
    }

    .list_img {
        margin-top: .8rem;
    }

    .list_img img {
        width: 7.5rem;
        height: 8rem;
    }

    .list_img {
        text-align: center;
    }

    .state_1 {
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        margin: .3rem auto;
        width: 2.4rem;
        height: .52rem;
        background: #FD602A;
        font-size: .24rem;
        line-height: .52rem;
        color: white;
        text-align: center;
        border-radius: .26rem;
    }

    .state_2,
    .state_3 {
        width: 92%;
        height: 1.6rem;
        position: absolute;
        top: 73%;
        left: 4%;
        background: white;
        border: 1px solid #8CCCFF;
        border-radius: 10px;
    }

    .tet {
        width: 2.58rem;
        height: .6rem;
        font-size: .24rem;
        position: absolute;
        left: 24%;
        margin-top: .5rem;
        color: #696969;
    }

    .tet_1 {
        color: #0791FB;
    }

    .btn {
        width: 1.6rem;
        height: .52rem;
        color: white;
        text-align: center;
        font-size: .24rem;
        background: #0791FB;
        position: absolute;
        right: 0;
        margin-right: .3rem;
        margin-top: .54rem;
        border-radius: .26rem;
        border: none;
    }

    .easc,
    .easc_1 {
        position: absolute;
        color: #0789FD;
        font-size: .24rem;
    }

    .easc {
        left: 10%;
        top: 29%;
    }

    .easc_1 {
        left: 8%;
        top: 45%;
    }
</style>



// WEBPACK FOOTER //
// src/components/thumbnail/breviary.vue